import { render, staticRenderFns } from "./moreIcon.vue?vue&type=template&id=3f98db6a&"
import script from "./moreIcon.vue?vue&type=script&lang=js&"
export * from "./moreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports